import { Link } from "react-router-dom";
import { Phone, Mail, Waves, Mountain } from "lucide-react";

export default function SiteFooter() {
  return (
    <footer data-testid="site-footer" className="bg-deep text-paper">
      <div className="mx-auto max-w-7xl px-5 py-20 sm:px-8">
        <div className="flex flex-col gap-12 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="font-serif text-4xl tracking-tight sm:text-5xl">
              Salt <span className="text-terra-light">&amp;</span> Stone
            </p>
            <p className="mt-3 max-w-sm text-base leading-relaxed text-paper/60">
              Guided hikes on Hydra island and the Saronic Gulf. No cars, no noise —
              just mule paths, pine forest and the Aegean below.
            </p>
          </div>
          <div className="flex flex-col gap-4 text-base">
            <a
              href="mailto:hello@saltstonehikes.com"
              data-testid="footer-email"
              className="flex items-center gap-3 text-paper/80 transition-colors duration-300 hover:text-terra-light"
            >
              <Mail size={15} /> hello@saltstonehikes.com
            </a>
            <a
              href="tel:+306976231058"
              data-testid="footer-phone"
              className="flex items-center gap-3 text-paper/80 transition-colors duration-300 hover:text-terra-light"
            >
              <Phone size={15} /> +(30) 6976 231 058
            </a>
            <div className="flex items-center gap-6 pt-2 text-sm uppercase tracking-[0.25em] text-paper/50">
              <Link to="/hikes" data-testid="footer-hikes-link" className="transition-colors duration-300 hover:text-paper">
                Hikes
              </Link>
              <Link to="/about" data-testid="footer-about-link" className="transition-colors duration-300 hover:text-paper">
                About
              </Link>
              <Link to="/contact" data-testid="footer-contact-link" className="transition-colors duration-300 hover:text-paper">
                Contact
              </Link>
            </div>
          </div>
        </div>
        <div className="mt-16 flex items-center justify-between border-t border-paper/10 pt-6 text-sm uppercase tracking-[0.25em] text-paper/40">
          <span className="flex items-center gap-2">
            <Waves size={13} /> Sea <Mountain size={13} /> Summit
          </span>
          <span>© {new Date().getFullYear()} Salt &amp; Stone · Hydra</span>
        </div>
      </div>
    </footer>
  );
}
